import {HTMLReactParserOptions, Element as ParserElement} from 'html-react-parser';

import {LanguageSwitcher, Copyright as CopyrightComponent, ClientLogo, NodeElement, ClientDynamicContent} from 'components';
import {DynamicComponentNames, LayoutUnits as Units, LAYOUT_DEFAULT_TEMPLATE} from 'constants/client';
import {dynamicContentUtils, imageUtils} from 'utils';

import './styles.scss';

const {isMatchElement, renderDefaultNode} = dynamicContentUtils;
const getOptions = (props: any): HTMLReactParserOptions => {
    const {
        hasLogo, image, hasTranslate, children, localParticipant
    } = props;
    return {
        replace: (domNode: any) => {
            if (!domNode.attribs) {
                return null;
            }

            const node = domNode as ParserElement;

            if (isMatchElement(Units.Logo, node)) {
                return (
                    <NodeElement node={node} show={hasLogo}>
                        <ClientLogo image={image || imageUtils.getLogo()} className={null} />
                    </NodeElement>
                );
            }
            if (isMatchElement(Units.Language, node)) {
                return (
                    <NodeElement node={node} show={hasTranslate}>
                        <LanguageSwitcher />
                    </NodeElement>
                );
            }
            if (isMatchElement(Units.Content, node)) {
                return <NodeElement node={node}>{children}</NodeElement>;
            }
            if (isMatchElement(Units.Copyright, node)) {
                return <NodeElement node={node}><CopyrightComponent /></NodeElement>;
            }
            return renderDefaultNode(node, {role: localParticipant?.role});
        }
    };
};

type Props = {
    // TODO: implement getting a logo from context
    image?: string;
    hasLogo?: boolean;
    hasTranslate?: boolean;
    children: React.ReactNode;
};

export const ClientDynamicLayout: React.FC<Props> = ({image, children, hasLogo = true, hasTranslate = true}) => (
    <ClientDynamicContent
        component={DynamicComponentNames.Layout}
        defaultTemplate={LAYOUT_DEFAULT_TEMPLATE}
        optionsProps={{hasLogo, image, hasTranslate, children}}
        optionsGetter={getOptions}
    />
);
